import styled from 'styled-components';

export const Container = styled.div`
  gap: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Input = styled.input`
  display: none;
`;
